import React from 'react';
import { motion } from 'framer-motion';
export function Process() {
  const steps = [{
    number: '01',
    title: 'Discovery & Audit',
    description: 'Deep-dive into your ICP, competitors, and existing content. We identify gaps and high-leverage opportunities.'
  }, {
    number: '02',
    title: 'Strategy Blueprint',
    description: 'We architect a comprehensive content roadmap mapped precisely to your revenue goals and buyer stages.'
  }, {
    number: '03',
    title: 'Production & Launch',
    description: 'Our SMEs execute systematic content creation and multi-channel distribution engineering.'
  }, {
    number: '04',
    title: 'Measure & Optimize',
    description: 'Continuous attribution tracking, performance analysis, and strategy refinement based on pipeline data.'
  }];
  return <section id="process" className="py-24 bg-white" data-id="element-152">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-153">
        <div className="mb-20" data-id="element-154">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-heading font-bold text-navy-900 mb-6" data-id="element-155">
            How we work.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-slate-600 max-w-2xl text-lg" data-id="element-156">
            A systematic, engineering-led approach to content marketing. No
            guesswork, just predictable execution.
          </motion.p>
        </div>

        <div className="relative" data-id="element-157">
          {/* Connecting Line */}
          <div className="absolute top-8 left-0 w-full h-px bg-slate-200 hidden md:block" data-id="element-158"></div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8" data-id="element-159">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="relative" data-id="element-160">
                {/* Node */}
                <div className="w-16 h-16 bg-white border-2 border-navy-900 flex items-center justify-center mb-8 relative z-10 clip-hexagon" data-id="element-161">
                  <span className="font-heading font-bold text-navy-900" data-id="element-162">
                    {step.number}
                  </span>
                </div>

                <h3 className="text-xl font-heading font-bold text-navy-900 mb-4" data-id="element-163">
                  {step.title}
                </h3>
                <p className="text-slate-600 leading-relaxed text-sm" data-id="element-164">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}